(function () {
  'use strict';

  var giftLabels = {
    de: 'Geschenknachricht',
    en: 'Gift Message',
    ru: 'Сообщение к подарку',
    ar: 'رسالة الهدية',
    tr: 'Hediye mesajı'
  };

  function localeKey() {
    var raw = String(
      (window.MOBlumenCartContact && window.MOBlumenCartContact.locale) ||
      document.documentElement.lang ||
      'de'
    ).toLowerCase();
    var key = raw.split('-')[0];
    return giftLabels[key] ? key : 'de';
  }

  function applyGiftLabel() {
    var text = giftLabels[localeKey()];

    document.querySelectorAll('cart-note').forEach(function (panel) {
      var heading = panel.querySelector('.cart-options-title');
      var label = panel.querySelector('label');
      var textarea = panel.querySelector('textarea[data-cart-note], textarea[name="note"]');

      if (heading) heading.textContent = text;
      if (label) label.textContent = text;
      if (textarea) textarea.setAttribute('aria-label', text);

      var footer = panel.closest('cart-footer-content');
      if (footer) {
        var trigger = footer.querySelector('a[href="#ordernote"] span');
        if (trigger) trigger.textContent = text;
      }
    });
  }

  function boot() {
    applyGiftLabel();

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyGiftLabel();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();